module.exports = __webpack_public_path__ + "static/media/playlist.9f084358.png";